import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IStep } from '@models/ui-models/step';

@Component({
  selector: 'app-clickable-stepper',
  standalone: true,
  templateUrl: 'clickable-stepper.component.html',
  styleUrl: 'clickable-stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClickableStepperComponent {
  steps = input<IStep[]>([]);
  currentStepIndex = input<number>(0);
  disableSteps = input<boolean>(false);

  stepIndexChange = output<number>();

  onStepChange(index: number): void {
    this.stepIndexChange.emit(index);
  }
}
